import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroPage from "./components/HeroPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import Dashboard from "./components/Dashboard";
import JournalList from "./components/JournalList";
import CommunityPage from "./components/CommunityPage";
import "./App.css"; // Import your CSS file
import Footer from "./components/Footer";
import { useAuth } from "./contexts/authContext";
import Pomodoro from "./components/Pomodoro";
import SettingsPage from "./pages/SettingsPage";
import WhiteBoard from "./components/WhiteBoard";
import WhiteboardGallery from "./components/WhiteBoardGallery";
import StatusBanner from "./components/StatusBanner";
import useGetHabits from "./hooks/useGetHabits";
import useGetGoals from "./hooks/useGetGoals";
import useGetTodos from "./hooks/useGetTodos";
import Loader from "./components/Loader"; // Assuming you have a Loader component
import Grocery from "./components/Grocery";
import InstallPrompt from "./components/InstallPrompt";
import Recipes from "./components/Recipes";
import RecipeSharePage from "./components/RecipeSharePage"; // Import your recipe share page
import DemoModeBanner from "./components/demoModeBanner"; // Import your demo mode banner

import NotesPage from "./pages/NotesPage";
//import { useInactivityReminder } from './hooks/useInactivityReminder';
import { messaging, getToken } from "./firebase/firebase";
import Schulte from "./components/Schulte";
import useServiceWorkerUpdate from "./hooks/useServiceWorkerUpdate";
import { initDB } from "./utils/offlineStorage";
import { toast } from "react-toastify";

const PomodoroWrapper = ({
  initialTitle,
  isRunning,
  setIsRunning,
  initialMinutes,
}) => {
  const location = useLocation();
  const showPomodoro =
    location.pathname !== "/" &&
    location.pathname !== "/login" &&
    location.pathname !== "/register";
  return showPomodoro ? (
    <Pomodoro
      initialTitle={initialTitle}
      isRunning={isRunning}
      setIsRunning={setIsRunning}
      initialMinutes={initialMinutes}
    />
  ) : null;
};

// Create a new component for content inside Router
const AppContent = ({
  theme,
  isGuest,
  pomodoroTitle,
  isPomodoroRunning,
  setIsPomodoroRunning,
  initialMinutes,
  triggerPomodoro,
}) => {
  const location = useLocation(); // Now safe to use here

  return (
    <>
      <Navbar />
      {isGuest && <Navbar />}
      {isGuest && <DemoModeBanner />}
      <StatusBanner />
      {/* Pomodoro Timer */}
      <PomodoroWrapper
        initialTitle={pomodoroTitle}
        isRunning={isPomodoroRunning}
        setIsRunning={setIsPomodoroRunning}
        initialMinutes={initialMinutes}
      />
      <Routes>
        <Route path="/" element={<HeroPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/dashboard"
          element={<Dashboard triggerPomodoro={triggerPomodoro} />}
        />
        <Route path="/journal-list" element={<JournalList />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/whiteboard" element={<WhiteBoard />} />
        <Route path="/whiteboard-gallery" element={<WhiteboardGallery />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/grocery" element={<Grocery />} />
        <Route path="/recipes" element={<Recipes />} />
        <Route path="/recipes/share/:id" element={<RecipeSharePage />} />
        <Route path="/notes" element={<NotesPage />} />
        <Route path="/schulte" element={<Schulte />} />
      </Routes>
      {location.pathname !== "/notes" && <Footer />}
    </>
  );
};

const App = () => {
  const { theme, currentUser } = useAuth();
  const isGuest = currentUser && currentUser.isAnonymous;
  const { loading: habitsLoading } = useGetHabits();

  const { loading: goalsLoading } = useGetGoals();
  const { loading: todosLoading } = useGetTodos();
  const { loading: authLoading } = useAuth(); // If your auth context provides loading

  useEffect(() => {
    async function requestFCMToken() {
      try {
        const token = await getToken(messaging, {
          vapidKey: process.env.VAPID_KEY,
        });
        return token;

        // Save token to your backend for later use
      } catch (err) {
        console.error("FCM token error:", err);
      }
    }
    requestFCMToken();
  }, []);

  // useEffect(() => {
  //   async function initOneSignal() {
  //     await OneSignal.init({
  //       appId: "47c26c0f-d61b-4716-9f62-f1f84ac305bc", // ✅ Your App ID
  //       notifyButton: {
  //         enable: true,
  //       },
  //       serviceWorkerPath: "service-worker.js", // ✅ Custom service worker
  //       serviceWorkerUpdaterPath: "service-worker.js",
  //       autoRegister: false, // ✅ Prevent auto-prompt
  //     });

  //     // Show slidedown prompt manually on page load
  //     OneSignal.showSlidedownPrompt().catch(console.error);
  //   }

  //   initOneSignal();
  // }, []);

  // useEffect(() => {
  //   // Dynamically load the OneSignal SDK script
  //   const script = document.createElement("script");
  //   script.src = "https://cdn.onesignal.com/sdks/OneSignalSDK.js";
  //   script.async = true;
  //   document.body.appendChild(script);

  //   script.onload = () => {
  //     window.OneSignal = window.OneSignal || [];
  //     window.OneSignal.push(function () {
  //       window.OneSignal.init({
  //         appId: "702b4e49-c8a5-4af7-8e99-ce0babb6706a",
  //         notifyButton: { enable: true },
  //         allowLocalhostAsSecureOrigin: true,
  //         serviceWorkerPath: "/service-worker.js",
  //       });

  //       window.OneSignal.getNotificationPermission().then((permission) => {
  //         if (permission === "default") {
  //           window.OneSignal.Slidedown.promptPush();
  //         }
  //       });
  //     });
  //   };

  //   // Optional: cleanup
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  // useEffect(() => {
  //   // Only run if user is logged in and OneSignal is loaded
  //   if (!currentUser || !window.OneSignal) return;

  //   window.OneSignal.getUserId().then(async (playerId) => {
  //     if (playerId) {
  //       // Save playerId to Firestore with the user's info
  //       await setDoc(
  //         doc(db, "userActivity", currentUser.uid),
  //         {
  //           playerId,
  //           lastActive: Date.now(),
  //           pomodoroStatus: localStorage.getItem("pomodoroStatus") || "stopped",
  //           email: currentUser.email,
  //         },
  //         { merge: true }
  //       );
  //     }
  //   });
  // }, [currentUser]);

  // useInactivityReminder();
  const [pomodoroTitle, setPomodoroTitle] = useState(""); // State to hold the Pomodoro session title
  const [isPomodoroRunning, setIsPomodoroRunning] = useState(false); // State to track if Pomodoro is running
  const [initialMinutes, setInitialMinutes] = useState(25); // Initial minutes for Pomodoro timer

  useEffect(() => {
    const storedMinutes = localStorage.getItem("pomodoroInitialMinutes");
    if (storedMinutes) {
      setInitialMinutes(parseInt(storedMinutes, 10));
    }
  }, []);

  // ==================== PWA INITIALIZATION ====================

  // Initialize offline database
  useEffect(() => {
    initDB()
      .then(() => console.log("[App] IndexedDB initialized"))
      .catch((error) =>
        console.error("[App] IndexedDB initialization failed:", error),
      );
  }, []);

  // Register service worker and handle updates
  useEffect(() => {
    const registerServiceWorker = async () => {
      if (!("serviceWorker" in navigator)) {
        console.log("[PWA] Service Workers not supported in this browser");
        return;
      }

      try {
        const registration = await navigator.serviceWorker.register(
          "/service-worker.js",
          {
            scope: "/",
            updateViaCache: "none", // Always check for new SW
          },
        );

        console.log(
          "[PWA] Service Worker registered successfully:",
          registration,
        );

        // Check for updates after 1 minute, then periodically
        setTimeout(() => {
          registration
            .update()
            .catch((error) =>
              console.error("[PWA] Error checking for SW updates:", error),
            );
        }, 60000);
      } catch (error) {
        console.error("[PWA] Service Worker registration failed:", error);
      }
    };

    // Register on app load
    registerServiceWorker();
  }, []);

  // Handle service worker updates with user notification
  useServiceWorkerUpdate((updateInfo) => {
    console.log("[PWA] New service worker version available");

    // Show update notification using toast
    toast.info(
      ({ closeToast }) => (
        <div>
          <p>A new version of LifeMastery is available!</p>
          <button
            onClick={() => {
              updateInfo.skipWaiting();
              closeToast();
            }}
            style={{
              marginTop: "10px",
              padding: "8px 16px",
              backgroundColor: "#2e3a59",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Update Now
          </button>
        </div>
      ),
      {
        autoClose: false,
        closeButton: true,
        position: "bottom-right",
      },
    );
  });

  // Listen for notifications from service worker
  useEffect(() => {
    const handleSWMessage = (event) => {
      const { type, notification } = event.data;

      if (type === "NOTIFICATION_CLICKED") {
        console.log("[PWA] Notification clicked:", notification);
        // Handle notification click (e.g., navigate to relevant page)
      }
    };

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", handleSWMessage);
    }

    return () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener("message", handleSWMessage);
      }
    };
  }, []);

  // ==================== END PWA INITIALIZATION ====================

  const triggerPomodoro = (title) => {
    setPomodoroTitle(title);
    setIsPomodoroRunning(true); // Start the Pomodoro session
  };

  // Show loader if any global data is loading
  if (habitsLoading || goalsLoading || todosLoading || authLoading) {
    return <Loader />;
  }
  return (
    <div className={theme === "dark" ? "dark" : ""}>
      <Router>
        <AppContent
          theme={theme}
          isGuest={isGuest}
          pomodoroTitle={pomodoroTitle}
          isPomodoroRunning={isPomodoroRunning}
          setIsPomodoroRunning={setIsPomodoroRunning}
          initialMinutes={initialMinutes}
          triggerPomodoro={triggerPomodoro}
        />
      </Router>
      <InstallPrompt />
    </div>
  );
};

export default App;
